class ParamsApi {
    async getParamAutomaticMail(admin_id) {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMail/get/`
        const values = {
            "admin_id": admin_id
        };
        const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const resp = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return Promise.resolve(json);
    };
    async setParamAutomaticMail(admin_id, isAutomaticMail) {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMail/set/`
        const values = {
            "admin_id": admin_id,
            "is_automatic_mail": isAutomaticMail,
        };
        const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const resp = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return Promise.resolve(json);
    };
    async getParamAutomaticMailToCustomer(admin_id) {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailToCustomer/get/`
        const values = {
            "admin_id": admin_id
        };
        const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const resp = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return Promise.resolve(json);
    };
    async setParamAutomaticMailToCustomer(admin_id, isAutomaticMail) {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailToCustomer/set/`
        const values = {
            "admin_id": admin_id,
            "is_automatic_mail_to_customer": isAutomaticMail,
        };
        const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const resp = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return Promise.resolve(json);
    };
    

// /////////////////////////////////////////////////////////////////////////////////////////
async getParamAutomaticMailAdminNewDevice(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailAdminNewDevice/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamAutomaticMailAdminNewDevice(admin_id, automatic_mails_AdminNewDevice) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailAdminNewDevice/set/`
    const values = {
        "admin_id": admin_id,
        "automatic_mail_AdminNewDevice": automatic_mails_AdminNewDevice,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};


// 
async getParamAutomaticMailUserNewDevice(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailUserNewDevice/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamAutomaticMailUserNewDevice(admin_id, automatic_mail_UserNewDevice) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailUserNewDevice/set/`
    const values = {
        "admin_id": admin_id,
        "automatic_mail_UserNewDevice": automatic_mail_UserNewDevice,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};

// 


async getParamAutomaticMailAdminFirstLogin(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailAdminFirstLogin/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamAutomaticMailAdminFirstLogin(admin_id, automatic_mails_AdminFirstLogin) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailAdminFirstLogin/set/`
    const values = {
        "admin_id": admin_id,
        "automatic_mails_AdminFirstLogin": automatic_mails_AdminFirstLogin,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};

// 

async getParamAutomaticMailUserFirstLogin(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailUserFirstLogin/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamAutomaticMailUserFirstLogin(admin_id, automatic_mails_UserFirstLogin) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/automaticMailUserFirstLogin/set/`
    const values = {
        "admin_id": admin_id,
        "automatic_mails_UserFirstLogin": automatic_mails_UserFirstLogin,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamAutoRelaunche(admin_id, auto_relaunche) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/autoRelaunche/set/`
    const values = {
        "admin_id": admin_id,
        "auto_relaunche": auto_relaunche,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};

async setParamSendMailSameEPP(admin_id, send_mail_same_epp) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/autoSameEpp/set/`
    const values = {
        "admin_id": admin_id,
        "send_mail_same_epp": send_mail_same_epp,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamTLMS_BRANCH_ID(admin_id, tlms_branch_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/tlms_branch_id/set/`
    const values = {
        "admin_id": admin_id,
        "tlms_branch_id": tlms_branch_id,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamTLMS_DOMAIN(admin_id, tlms_domain) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/tlms_domain/set/`
    const values = {
        "admin_id": admin_id,
        "tlms_domain": tlms_domain,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamTLMS_ADDRESS(admin_id, tlms_address) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/tlms_address/set/`
    const values = {
        "admin_id": admin_id,
        "tlms_address": tlms_address,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamAPPLICATION_DAYS(admin_id, application_days) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/application_days/set/`
    const values = {
        "admin_id": admin_id,
        "application_days": application_days,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async setParamPATIENTS_NUMBER(admin_id, patient_number) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/patients_number/set/`
    const values = {
        "admin_id": admin_id,
        "patient_number": patient_number,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};

async getParamAutoRelaunche(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/AutoRelaunche/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async getParamSendMailSameEPP(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/SendMailSameEPP/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async getParamTLMS_BRANCH_ID(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/tlms_branch_id/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async getParamTLMS_DOMAIN(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/tlms_domain/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async getParamTLMS_ADDRESS(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/tlms_address/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async getParamAPPLICATION_DAYS(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/application_days/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async getParamPATIENTS_NUMBER(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/patients_number/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
async getParamDisplayLearnerSpentTime(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/config/display_learner_spent_time/get/`
    const values = {
        "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json);
};
}
export const paramsApi = new ParamsApi();